<template>
  <svg
    class="icon"
    :class="{'icon--spin':spin}"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-width="2"
      style="stroke:currentColor;"
    >
      <path d="m4 11 4 3 4-3" />
      <path d="m4 2 4 3 4-3" transform="matrix(1 0 0 -1 0 7)" />
    </g>
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>
